import { FC, useEffect } from "react";

import { useGetOnmetaKycUrlMutation } from "../../../store/services/user";

const hostName = new URL(window.location.href).hostname;
const params = new URLSearchParams();
params.set("successRedirectUrl", `${hostName}/onmeta-kyc-success`);
params.set("failureRedirectUrl", `${hostName}/onmeta-kyc-failure`);

export const OnmetaKycForm: FC = () => {
  const [getKycToken, { data, reset }] = useGetOnmetaKycUrlMutation();

  useEffect(() => {
    if (!data) {
      getKycToken();
    }
  }, [data, getKycToken]);

  useEffect(() => {
    // Reset request on unmount to get new token on each mount (like clear cache)
    return () => reset();
  }, [reset]);

  if (!data?.onmeta_kyc_url) {
    return <>Fetching Onmeta KYC Data</>;
  }

  const kycUrl = `${data?.onmeta_kyc_url}&${params.toString()}`;

  return <iframe title="Onmeta KYC" src={kycUrl} height={600} allow="camera" />;
};
